function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "32",
  height: "39",
  viewBox: "0 0 32 39",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), React.createElement("defs", null, React.createElement("path", {
  id: "redo-marker-path-1",
  d: "M0 .756h31.305v38.222H0z"
})), React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(0 -.734)"
}, React.createElement("mask", {
  id: "redo-marker-mask-2",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#redo-marker-path-1"
})), React.createElement("path", {
  d: "M21.42 28.148c-.259.216-.49.41-.69.584-2.014 1.746-3.789 3.81-5.077 5.849-1.289-2.04-3.064-4.103-5.078-5.85-.2-.173-.43-.367-.689-.583-2.517-2.111-7.752-6.504-7.752-12.917 0-6.764 6.19-12.477 13.519-12.477 7.328 0 13.519 5.713 13.519 12.477 0 6.415-5.236 10.806-7.753 12.917M15.653.756C7.322.756 0 7.185 0 15.231c0 7.97 6.82 12.967 9.125 14.965 3.042 2.639 5.401 5.969 6.242 8.574.045.14.164.208.286.208a.292.292 0 00.286-.208c.84-2.605 3.2-5.935 6.24-8.574 2.306-1.998 9.126-6.996 9.126-14.965 0-8.046-7.32-14.475-15.652-14.475",
  fill: "currentColor",
  mask: "url(#redo-marker-mask-2)"
})), React.createElement("path", {
  d: "M19.643 7.562a9.298 9.298 0 00-6.722-.561 8.843 8.843 0 00-3.992 2.457l-.324-.967c-.177-.533-.79-.831-1.363-.665a1.06 1.06 0 00-.64.5.955.955 0 00-.073.776L7.53 12.09c.01.038.023.074.03.088l.262.783 4.423-.765c.286-.05.535-.202.7-.426a.958.958 0 00.172-.76 1.015 1.015 0 00-.454-.658 1.123 1.123 0 00-.815-.162l-.762.132a6.647 6.647 0 012.488-1.375c3.498-1.022 7.232.806 8.33 4.072 1.095 3.274-.855 6.772-4.35 7.799a7.005 7.005 0 01-5.064-.42c-1.572-.769-2.73-2.065-3.264-3.652a1.025 1.025 0 00-.533-.599 1.141 1.141 0 00-.832-.068c-.572.168-.89.741-.71 1.279.703 2.103 2.241 3.823 4.33 4.846a9.312 9.312 0 006.726.557c4.64-1.362 7.23-6.007 5.773-10.354-.706-2.101-2.246-3.821-4.337-4.844",
  fill: "currentColor"
}))));